import { render, staticRenderFns } from "./add-route.vue?vue&type=template&id=702e0010&"
import script from "./add-route.vue?vue&type=script&lang=js&"
export * from "./add-route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports